class ProductShippingCountdown extends HTMLElement {
  connectedCallback() {
    this.cutoffHour = Number(this.dataset.cutoffHour) || 11;
    this.timezone = this.dataset.timezone || 'Europe/Istanbul';
    this.timeEl = this.querySelector('[data-shipping-time]');
    this.midEl = this.querySelector('[data-shipping-mid]');
    this.highlightEl = this.querySelector('[data-shipping-highlight]');

    if (!this.timeEl || !this.highlightEl) return;

    this.update();
    this.interval = window.setInterval(() => this.update(), 60000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);
  }

  #getZonedParts(date) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: this.timezone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    });

    return Object.fromEntries(
      formatter.formatToParts(date).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)])
    );
  }

  #deliveryDayName(sameDay) {
    const parts = this.#getZonedParts(new Date());
    const base = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
    const addDays = sameDay ? 2 : 3;
    base.setUTCDate(base.getUTCDate() + addDays);
    return new Intl.DateTimeFormat('tr-TR', {
      weekday: 'long',
      timeZone: 'UTC',
    }).format(base);
  }

  #getRemainingMinutes() {
    const now = new Date();
    const { hour, minute } = this.#getZonedParts(now);
    const nowMinutes = hour * 60 + minute;
    const cutoffMinutes = this.cutoffHour * 60;

    if (nowMinutes < cutoffMinutes) {
      return {
        total: cutoffMinutes - nowMinutes,
        sameDay: true,
      };
    }

    return {
      total: 24 * 60 - nowMinutes + cutoffMinutes,
      sameDay: false,
    };
  }

  update() {
    const { total, sameDay } = this.#getRemainingMinutes();
    const hours = Math.floor(total / 60);
    const minutes = total % 60;
    const compact = this.dataset.compact === 'true';
    const dayLabel = this.#deliveryDayName(sameDay);

    if (compact) {
      this.timeEl.textContent =
        hours > 0 ? `${hours} saat ${minutes} dk` : `${minutes} dk`;
      this.highlightEl.textContent = `${dayLabel} kapında`;
      this.setAttribute(
        'aria-label',
        `${this.timeEl.textContent} içinde sipariş ver en geç ${dayLabel} kapında`
      );
      return;
    }

    this.timeEl.textContent =
      hours > 0 ? `${hours} saat ${minutes} dakika` : `${minutes} dakika`;
    if (this.midEl) this.midEl.textContent = ' içinde sipariş verirsen en geç ';
    this.highlightEl.textContent = `${dayLabel} kapında`;
    this.removeAttribute('aria-label');
  }
}

if (!customElements.get('product-shipping-countdown')) {
  customElements.define('product-shipping-countdown', ProductShippingCountdown);
}
